import React from 'react';

const baseClasses =
  'inline-flex items-center rounded-full px-2 py-1 text-[10px] font-bold uppercase';

const variantClasses: Record<NonNullable<BadgeProps['variant']>, string> = {
  neutral: 'bg-slate-100 text-slate-600',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-amber-100 text-amber-700',
  danger: 'bg-red-100 text-red-700',
  info: 'bg-blue-100 text-blue-700'
};

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: 'neutral' | 'success' | 'warning' | 'danger' | 'info';
};

export const Badge: React.FC<BadgeProps> = ({ variant = 'neutral', className = '', ...props }) => (
  <span className={`${baseClasses} ${variantClasses[variant]} ${className}`} {...props} />
);
